var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2.196 2.014",
    fill: "#00A800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1.642 0c0.153,0 0.291,0.062 0.392,0.163 0.1,0.1 0.163,0.239 0.163,0.392l0 0.906c0,0.152 -0.062,0.291 -0.163,0.392 -0.1,0.1 -0.239,0.163 -0.392,0.163l-1.087 0c-0.152,0 -0.291,-0.062 -0.392,-0.163 -0.1,-0.1 -0.163,-0.239 -0.163,-0.392l0 -0.906c0,-0.153 0.062,-0.291 0.163,-0.392 0.1,-0.1 0.239,-0.163 0.392,-0.163l1.087 0zm0.271 0.283c-0.07,-0.07 -0.166,-0.113 -0.271,-0.113l-1.087 0c-0.105,0 -0.201,0.043 -0.271,0.113 -0.07,0.07 -0.113,0.166 -0.113,0.271l0 0.906c0,0.105 0.043,0.201 0.113,0.271 0.07,0.07 0.166,0.113 0.271,0.113l1.087 0c0.105,0 0.201,-0.043 0.271,-0.113 0.07,-0.07 0.113,-0.166 0.113,-0.271l0 -0.906c0,-0.105 -0.043,-0.201 -0.113,-0.271zm-0.737 1.229c-0.043,0.043 -0.113,0.043 -0.156,0l-0.474 -0.474c-0.053,-0.06 -0.086,-0.14 -0.086,-0.227 0,-0.189 0.153,-0.342 0.342,-0.342 0.122,0 0.234,0.065 0.296,0.17 0.061,-0.105 0.174,-0.17 0.296,-0.17 0.189,0 0.342,0.154 0.342,0.342 0,0.087 -0.032,0.166 -0.086,0.227l-0.474 0.474z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteColor);
export default __webpack_public_path__ + "static/media/favorite-color.036f3b98ee779112c9d2b25045beb375.svg";
export { ForwardRef as ReactComponent };